"use strict";

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Vraci normalizovanou URI.
 *
 * @param {string} path
 *
 * @returns String root pathy bez duplicitnich lomitek
 */
var sanitizeUrl = function sanitizeUrl() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var result = path.replace(/^\//, '').replace(/\/+/g, '/').replace(/\/$/, '');
  return "/".concat(result, "/");
};

var _default = sanitizeUrl;
exports.default = _default;